import { toast } from 'react-toastify';
import { ApiError } from '../api/client';

/** HTTP status the API uses when a write would change a closed financial year. */
export const PERIOD_LOCKED_STATUS = 423;

export function isPeriodLockedError(e: unknown): e is ApiError {
  return e instanceof ApiError && e.status === PERIOD_LOCKED_STATUS;
}

/**
 * Background saves are local-first. When the server refuses one because its financial year
 * is closed, tell the user and reload the server copy so the refused edit doesn't linger in
 * the local cache (and doesn't block every later save of the same bundle).
 * Returns true when the error was a closed-year rejection.
 */
export function handleSyncRejection(e: unknown): boolean {
  if (!isPeriodLockedError(e)) return false;
  toast.error(e.message, { toastId: `period-locked:${e.message}`, autoClose: 10000 });
  void import('./cloudSync').then((m) => m.hydrateTenantWorkspace()).catch(() => {});
  return true;
}
